import React from "react";
import { SxProps, useTheme } from "@mui/material/styles";
import {
    CheckboxContainer, 
    CustomCheckbox,
    CustomLabel
} from "./Checkbox.styles";
import { Variants, SizeStyles, CheckedStyles } from "./Checkbox.variants";
import { Icon } from "../../icons";

export interface CustomVariantCheckboxProps {
    variant?: "primary" | "secondary";
    size?: "xs" | "sm" | "md" | "lg";
    sx?: SxProps;
    label?: string | React.ReactElement;
    checked?: boolean;
    disabled?: boolean;
    onChange: (check: boolean) => void;
}

export const Checkbox = ({
    variant = "primary",
    size = "md",
    label = "",
    checked = false,
    disabled = false,
    onChange,
    sx,
    ...rest
}: CustomVariantCheckboxProps) => {
    const theme = useTheme();

    const variantStylesFn = Variants(theme);
    const sizeStylesFn = SizeStyles(theme);
    const checkedStylesFn = CheckedStyles(theme);
    const conditionalCheckFillColor = checked ? checkedStylesFn : {};

    return (
        <CheckboxContainer>
            <CustomCheckbox
                onChange={() => onChange(!checked)}
                checked={checked}
                disabled={disabled}
                className={checked ? "isChecked" : ""}
                sx={{
                    ...variantStylesFn[variant],
                    ...sizeStylesFn[size],
                    ...conditionalCheckFillColor,
                    ...sx
                }}
                icon={checked ? <Icon icon={"Check"} size={size === "xs" ? "sm" : size} /> : <></>}
                checkedIcon={<Icon icon={"Check"} size={size === "xs" ? "sm" : size} />}
                {...rest}
                />
                <CustomLabel
                    sx={{
                        ...sizeStylesFn[size]}}>
                    {label}
                </CustomLabel>
        </CheckboxContainer>
    );
}

Checkbox.displayName = "Checkbox";